import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import Contato from "./Contato";
import Reveal from "./Reveal";
import {
  ArrowLeft,
  ExternalLink,
  Github,
  Briefcase,
  Code,
  MapPin,
} from "./Icons";

/*
 * Casca compartilhada das páginas de detalhe de projeto:
 * hero + showcase + conteúdo (article + aside) + CTA + footer.
 */
function ProjetoLayout({
  titulo,
  tagline,
  liveUrl,
  repoUrl,
  capa,
  capaAlt,
  tags = [],
  meta = [],
  children,
}) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Header />

      <header className="proj-hero">
        <div className="container">
          <div className="proj-hero-inner">
            <Link to="/" className="proj-back">
              <ArrowLeft /> Voltar para o portfólio
            </Link>
            <h1>{titulo}</h1>
            <p>{tagline}</p>
            <div className="proj-hero-cta">
              {liveUrl && (
                <a
                  className="btn btn-primary"
                  href={liveUrl}
                  target="_blank"
                  rel="noreferrer"
                >
                  Acessar projeto <ExternalLink />
                </a>
              )}
              {repoUrl && (
                <a
                  className="btn btn-ghost"
                  href={repoUrl}
                  target="_blank"
                  rel="noreferrer"
                >
                  <Github /> Código
                </a>
              )}
            </div>
          </div>
        </div>
      </header>

      {capa && (
        <div className="container">
          <Reveal className="proj-showcase">
            <img src={capa} alt={capaAlt || titulo} />
          </Reveal>
        </div>
      )}

      <section className="section">
        <div className="container">
          <div className="proj-content">
            <article className="proj-article">{children}</article>

            <aside className="proj-aside">
              {tags.length > 0 && (
                <div className="aside-card">
                  <h4>Tecnologias</h4>
                  <div className="aside-tags">
                    {tags.map((t) => (
                      <span className="tag" key={t}>
                        {t}
                      </span>
                    ))}
                  </div>
                </div>
              )}

              <div className="aside-card">
                <h4>Sobre o projeto</h4>
                <div className="aside-meta">
                  {(meta.length
                    ? meta
                    : [
                        { ic: "code", label: "Tipo", value: "Full-stack" },
                        { ic: "role", label: "Papel", value: "Desenvolvedor" },
                        { ic: "local", label: "Local", value: "Joinville · SC" },
                      ]
                  ).map((m, i) => {
                    const Ic =
                      m.ic === "role"
                        ? Briefcase
                        : m.ic === "local"
                        ? MapPin
                        : Code;
                    return (
                      <div className="row" key={i}>
                        <span className="ic">
                          <Ic />
                        </span>
                        <span>
                          <small>{m.label}</small>
                          <b>{m.value}</b>
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>

              {liveUrl && (
                <a
                  className="btn btn-primary"
                  href={liveUrl}
                  target="_blank"
                  rel="noreferrer"
                  style={{ width: "100%" }}
                >
                  Acessar projeto <ExternalLink />
                </a>
              )}
            </aside>
          </div>
        </div>
      </section>

      <Contato
        titulo="Gostou deste projeto?"
        texto="Posso desenvolver algo assim — ou sob medida — para o seu negócio. Vamos conversar?"
      />

      <Footer />
    </div>
  );
}

export default ProjetoLayout;
